/**
 * Production-safe logging utility
 *
 * Usage:
 *   logger.dev('Debug info') // Only logs in development
 *   logger.error('Error message', error) // Always logs
 *   logger.warn('Warning') // Always logs
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Development-only logging
   * Will not output anything in production
   */
  dev: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Error logging - always enabled
   * Use for actual errors that should be tracked
   */
  error: (...args: unknown[]) => {
    console.error(...args);
  },

  /**
   * Warning logging - always enabled
   * Use for non-critical issues that need attention
   */
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },

  /**
   * Conditional logging based on custom condition
   * Useful for feature flags or specific debug scenarios
   */
  conditional: (condition: boolean, ...args: unknown[]) => {
    if (condition) {
      console.log(...args);
    }
  },
};
